import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { SessiontempComponent } from '../../sessiontemp/sessiontemp.component';



@Injectable()
export class MyserviceService {


  timedOut = false;
  progressBarPopup: MatDialogRef<SessiontempComponent>;
  constructor(
    private idle: Idle,
    private dialog: MatDialog,
    private keepalive: Keepalive,
    private router: Router
  ) { }

  idleNew: any = null;
  idleMainState: string;

  setIdleObject(idleObj) {
    this.idleNew = idleObj;
  }

  getIdleObject() {
    return this.idleNew;
  }


  setState(strValue) {
    this.idleMainState = strValue;
  }
  getState() {
    return this.idleMainState;
  }

  /* callSessionTimeout()
  { 

       alert("Call Session Time out");
        
       this.idle.setIdle(5);
       
       
       this.idle.setTimeout(10);
       
       
       this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
       this.idle.onIdleEnd.subscribe(() => {
         this.idleState = 'NO_LONGER_IDLE';
   
       });
       
       this.idle.onTimeout.subscribe(() => {
         this.idleState = 'TIMED_OUT';
         this.timedOut = true;
         this.closeProgressForm();
       });
       
       this.idle.onIdleStart.subscribe(() => {
         this.idleState = 'IDLE_START', this.openProgressForm(1);
       });
       
       this.idle.onTimeoutWarning.subscribe((countdown: any) => {
         this.sessionForm(countdown);
       });
       
       
       this.keepalive.interval(15);
       
       
       this.reset();

       
  }

  
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
    
    }

  public openProgressForm(count: number) {
    
   this.progressBarPopup = this.dialog.open(SessiontempComponent,{hasBackdrop:true,disableClose:true});  
   this.progressBarPopup.componentInstance.count = count;

   this.progressBarPopup.afterClosed().subscribe(result=>{

    this.resetTimeOut();
    

      this. logout();
   });
   }


   logout() {
   
      this.userService.getslogout()
   
    this.userService.purgeAuth();
    
    
    if(window.localStorage['plogin'])
    {
      var plogin = window.localStorage['plogin']
      window.localStorage.removeItem('plogin');
      window.localStorage.clear()
      this.router.navigateByUrl('/plogin/'+plogin);
      
    }
    else{
   
    window.localStorage.clear()
    this.router.navigateByUrl('/login');
    }
    
  }

   closeProgressForm() {
    this.progressBarPopup.close();
   
    }

    resetTimeOut() {
     
        this.idle.ngOnDestroy();
    
    }

    public sessionForm(countdown: any): any {
    this.idleState = 'IDLE_TIME_IN_PROGRESS';
    
    this.progressBarPopup.componentInstance.count = (Math.floor((countdown - 1) / 60) + 1);
    this.progressBarPopup.componentInstance.progressCount = this.reverseNumber(countdown);
    this.progressBarPopup.componentInstance.countMinutes = (Math.floor(countdown / 60));
    this.progressBarPopup.componentInstance.countSeconds = countdown%60;
    }

    reverseNumber(countdown: number) {
      return (300 - (countdown - 1));
    } */



}
